import { useContext } from 'react';
import { SiteContext } from './context.js';
import type { SiteContextState } from './context.js';

export function useSite(): SiteContextState {
  const context = useContext(SiteContext);
  if (context == null) {
    throw new Error('useSite() cannot be used without an <SiteProvider>');
  }
  return context;
}
